import { render, staticRenderFns } from "./BirthsList.vue?vue&type=template&id=2979a407"
import script from "./BirthsList.vue?vue&type=script&lang=js"
export * from "./BirthsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports